import styled from "styled-components";

export const Footer = styled.footer`
  background-color: #1A1814;
  padding: 32px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FooterText = styled.p`
  color: #ffffff;
  font-size: 0.875rem;
  margin: 0;
  letter-spacing: 0.02em;
`;
